import { SnackbarProvider } from "notistack";
import { useTheme } from "@mui/material";

import ExtensionAPIProvider from "./providers/ExtensionAPIProvider";
import UpstreamUpdateProvider from "./providers/UpstreamUpdateProvider";
import BreakpointProvider from "./providers/BreakpointProvider";
import AuthProvider from "./providers/AuthProvider";
import ApiProvider from "./providers/ApiProvider";
import AgentProvider from "./providers/AgentProvider";
import EnvironmentProvider from "./providers/EnvironmentProvider";
import SupabaseProvider from "./providers/SupabaseProvider";
import LoginStateProvider from "./providers/LoginStateProvider";
import AccountProvider from "./providers/AccountProvider";
import UserAPIProvider from "./providers/UserAPIProvider";
import TaskCommentsProvider from "./providers/TaskCommentsProvider";
import TaskAPIProvider from "./providers/TaskAPIProvider";
import TypingProvider from "./providers/TypingProvider";
import LocalSoundCacheProvider from "./providers/LocalSoundCacheProvider";
import AppNotificationProvider from "./providers/AppNotificationProvider";
import NotificationListProvider from "./providers/NotificationListProvider";
import TimelinePaginationProvider from "./providers/TimelinePaginationProvider";
import SurveyProvider from "./providers/SurveyProvider";
import SocketProvider from "./providers/SocketProvider";
import AwayStatusProvider from "./providers/AwayStatusProvider";
import AreYouSureProvider from "./providers/AreYouSureProvider";
import ReadStatusProvider from "./providers/ReadStatusProvider";
import RouteComponent from "./Routes";
import TreeStateProvider, { TYPES } from "./providers/TreeStateProvider";
import MediaLoadedProvider from "./providers/MediaLoadedProvider";
import NotificationCountProvider from "./providers/NotificationCountProvider";
import OnNotesProvider from "./providers/OnNotesProvider";
import RolesPermissionsProvider from "./providers/RolesPermissionsProvider";
import IntegrationProvider from "./providers/IntegrationProvider";
import StatsProvider from "./providers/StatsProvider";
import EnterModeProvider from "./providers/EnterModeProvider";
import MenuVisibilityProvider from "./providers/MenuVisibilityProvider";
import UIPaginationStateProvider from "./providers/UIPaginationStateProvider";
import TaskPageStateProvider from "./providers/TaskPageStateProvider";
import TaskFiltersProvider from "./providers/TaskFiltersProvider";
import TaskSWRMutateCacheProvider from "./providers/TaskSWRMutateCache";
import TaskListProvider from "./providers/TaskListProvider";
import ChatScrollProvider from "./providers/ChatScrollProvider";
import TaskCardStateProvider from "./providers/TaskCardStateProvider";
import NoteVisibilityProvider from "./providers/NoteVisibilityProvider";
import MetaProvider from "./providers/MetaProvider";
import EditProvider from "./providers/EditProvider";
import CustomerProvider from "./providers/CustomerProvider";

import combineComponents from "./utilities/combineComponents";

const providers = [
  ExtensionAPIProvider,
  UpstreamUpdateProvider,
  BreakpointProvider,
  AuthProvider,
  ApiProvider,
  AgentProvider,
  LoginStateProvider,
  AccountProvider,
  EnvironmentProvider,
  SupabaseProvider,
  UserAPIProvider,
  TaskCommentsProvider,
  TaskPageStateProvider,
  // Needed to preserve filters between pages and refresh when needed
  TaskCardStateProvider,
  TaskSWRMutateCacheProvider,
  TaskAPIProvider,
  IntegrationProvider,
  AwayStatusProvider,
  TypingProvider,
  LocalSoundCacheProvider,
  (props) => (
    <SnackbarProvider
      {...props}
      anchorOrigin={{
        horizontal: "center",
        vertical: "bottom",
      }}
    />
  ),
  AppNotificationProvider,
  ReadStatusProvider,
  MediaLoadedProvider,
  NotificationListProvider,
  TimelinePaginationProvider,
  SurveyProvider,
  SocketProvider,
  NotificationCountProvider,
  RolesPermissionsProvider,
  AreYouSureProvider,
  // Create a tree state provider of each type
  ...Object.values(TYPES).map((type) => (props) => (
    <TreeStateProvider type={type} {...props} />
  )),
  OnNotesProvider,
  StatsProvider,
  EnterModeProvider,
  MenuVisibilityProvider,
  UIPaginationStateProvider,
  TaskFiltersProvider,
  TaskListProvider,
  ChatScrollProvider,
  NoteVisibilityProvider,
  // Needed for ActionButton
  MetaProvider,
  EditProvider,
  CustomerProvider,
];

const AppContextProvider = combineComponents(...providers);

const App = () => {
  const theme = useTheme();

  return (
    <AppContextProvider>
      <div style={{ fontSize: theme.size.base }}>
        <RouteComponent />
      </div>
    </AppContextProvider>
  );
};

export default App;
